/**
 * Registre central des lots qui exposent un drawer de mapping référentiel
 * école-scoped. Consommé par `LotsTable` (affichage du bouton Settings) et
 * par `LotMappingDialog` (dispatcher type/ressource V2).
 *
 * Ajouter une entrée ici quand un nouveau lot a besoin de mapping :
 *  - clé = `MigrationStepDefinition.code`
 *  - type = type de référentiel utilisé côté MigrationSchoolReferentialOverride
 *  - v2Resource = ressource exposée par le proxy `/api/education-nationale/`
 *    (uniquement pour les nomenclatures normalisées comme cycles/niveaux)
 *  - v2Label = libellé colonne dans le drawer
 *
 * Deux familles de drawer cohabitent :
 *  - **`v2Resource` défini** → `LotMappingDialog` (nomenclature normalisée V2)
 *  - **`v2Resource = null`** → drawer dédié (ex: `CustomFieldsMappingDialog`
 *    pour `custom_field` qui cible un enum statique `AttributeType` V2)
 */
export const LOT_MAPPING_REGISTRY: Record<
  string,
  { type: string; v2Resource: string | null; v2Label: string; enCodeKind?: 'mef' | 'matiere' }
> = {
  'school.cycles': { type: 'cycle', v2Resource: 'cycles', v2Label: 'Cycle V2' },
  // Niveaux — en plus du niveau normalisé, on peut porter le code MEF
  // (Éducation Nationale) pour surcharger, par école, le MEF du défaut global.
  'school.levels': { type: 'niveau', v2Resource: 'niveaux', v2Label: 'Niveau V2', enCodeKind: 'mef' },
  // Matières — nomenclature normalisée `matieres` (nom) + code BCN EN
  // (surcharge école) qui active la normalisation matière côté V2.
  'school.subjects': { type: 'matiere', v2Resource: 'matieres', v2Label: 'Matière V2', enCodeKind: 'matiere' },
  // Champs personnalisés — pas de catalogue V2 normalisé, type cible = enum
  // statique `AttributeType` (STRING, EMAIL, SELECT…). Drawer dédié.
  'parents.fathers': { type: 'custom_field', v2Resource: null, v2Label: 'Type V2' },
  'parents.mothers': { type: 'custom_field', v2Resource: null, v2Label: 'Type V2' },
  'students.eleves': { type: 'custom_field', v2Resource: null, v2Label: 'Type V2' },
};

/** Set dérivé pour les checks rapides côté `LotsTable`. */
export const LOTS_WITH_MAPPING = new Set<string>(Object.keys(LOT_MAPPING_REGISTRY));
